<template>
  <div class="closure-calendar">
    <div class="d-flex align-center justify-space-between mb-1">
      <v-btn icon small retain-focus-on-click :disabled="!canGoPrev" aria-label="上個月" @click="moveMonth(-1)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <span class="font-weight-bold">{{ year }} 年 {{ monthIndex + 1 }} 月</span>
      <v-btn icon small retain-focus-on-click aria-label="下個月" @click="moveMonth(1)">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
    <div class="closure-calendar__grid">
      <div
        v-for="weekday in weekdays"
        :key="weekday"
        class="closure-calendar__weekday"
      >{{ weekday }}</div>
      <template v-for="(cell, index) in cells">
        <div v-if="!cell" :key="`blank-${index}`"/>
        <button
          v-else
          :key="cell.date"
          type="button"
          class="closure-calendar__day"
          :class="dayClass(cell.date)"
          :disabled="isUnavailable(cell.date)"
          :aria-pressed="String(value.includes(cell.date))"
          @click="toggle(cell.date)"
        >
          {{ cell.day }}
          <small v-if="closedDates.includes(cell.date)">已關閉</small>
        </button>
      </template>
    </div>
  </div>
</template>

<script>
import { buildCalendarCells, taipeiToday } from "@/utils/slotClosure";

export default {
  name: "SlotClosureCalendar",

  props: {
    value: {
      type: Array,
      required: true
    },
    closedDates: {
      type: Array,
      required: true
    }
  },

  data() {
    const today = taipeiToday()
    return {
      today,
      weekdays: ['日', '一', '二', '三', '四', '五', '六'],
      year: Number(today.slice(0, 4)),
      monthIndex: Number(today.slice(5, 7)) - 1
    }
  },

  computed: {
    cells() {
      return buildCalendarCells(this.year, this.monthIndex)
    },
    canGoPrev() {
      return this.year > Number(this.today.slice(0, 4)) || this.monthIndex > Number(this.today.slice(5, 7)) - 1
    }
  },

  methods: {
    moveMonth(step) {
      const next = new Date(Date.UTC(this.year, this.monthIndex + step, 1))
      this.year = next.getUTCFullYear()
      this.monthIndex = next.getUTCMonth()
    },
    isUnavailable(date) {
      return date < this.today || this.closedDates.includes(date)
    },
    dayClass(date) {
      return {
        'closure-calendar__day--past': date < this.today,
        'closure-calendar__day--closed': this.closedDates.includes(date),
        'closure-calendar__day--selected': this.value.includes(date),
        'font-weight-bold': date === this.today
      }
    },
    toggle(date) {
      const dates = this.value.includes(date)
        ? this.value.filter(selected => selected !== date)
        : [...this.value, date].sort()
      this.$emit('input', dates)
    }
  }
}
</script>

<style scoped>
.closure-calendar {
  max-width: 430px;
}

.closure-calendar__grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 4px;
}

.closure-calendar__weekday {
  padding: 4px 0;
  text-align: center;
  font-size: 12px;
  color: #757575;
}

.closure-calendar__day {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 46px;
  border: 1px solid transparent;
  border-radius: 4px;
  font-size: 14px;
  color: #333;
}

.closure-calendar__day small {
  font-size: 10px;
  line-height: 1.2;
}

.closure-calendar__day:hover:enabled,
.closure-calendar__day:focus-visible {
  border-color: var(--v-primary-base);
}

.closure-calendar__day--past {
  color: #c8c8c8;
  cursor: default;
}

.closure-calendar__day--closed {
  background: #f2f2f2;
  color: #9e9e9e;
  cursor: default;
}

.closure-calendar__day--selected {
  background: var(--v-tiffany-7-base);
  color: #fff;
}
</style>
